module.exports = __webpack_public_path__ + "assets/img/7cc6-gf.svg";